<template>
    <div class="language-switcher">
        <div class="language-switcher__result">PT</div>
        <div class="language-switcher__dropdown">
            <ul class="language-chooser">
                <li>
                    <a href="#" class="lang"> EN </a>
                </li>
                <li>
                    <a href="#" class="lang active">PT</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {};
</script>
